import  React, {useEffect, useState} from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CancelIcon from '@mui/icons-material/Cancel';

import axios from 'axios';
import cookie from "react-cookies";
import DatePicker from "react-datepicker";
import { MOBILE_WEB_BASE_URL } from '../../unified/webbase';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  boxShadow: 24,
};

export default function ResellerButton({open, handleClose, dspAirtime,dspCable,dspData,dspElectricity,dspInternet,dspJamb,dspWaec, email}) {
     
     
    const [value, setValue] = useState('')
    const token = cookie.load("token")
  
    const [dspAirtimee, setDspAirtime] = useState(dspAirtime)
    const [dspCablee, setDspCablee] = useState(dspCable)
    const [dspDataa, setDspData] = useState(dspData)
    const [dspElectricityy, setDspElectricity] = useState(dspElectricity)
    const [dspInternett, setDspInternet] = useState(dspInternet)
    const [dspJambb, setDspJamb] = useState(dspJamb)
    const [dspWaecc, setdspWaec] = useState(dspWaec)

    const setThresholdValue = (e) =>{
        e.preventDefault()
        const id = toast.loading("Please wait...");
    const valuess = {
        "dspAirtime": dspAirtimee,
  "dspCable": dspCablee,
  "dspData": dspDataa,
  "dspElectricity": dspElectricityy,
  "dspInternet": dspInternett,
  "dspJamb": dspJambb,
  "dspWaec": dspWaecc,
       "emailAddress": email
    }

    axios
    .post(MOBILE_WEB_BASE_URL + "/upgrade-user", valuess,  {
      headers: {
        authorization: token,
      },
    })
    .then((res) => {
      if (res.data.status === "2000") {
        toast.update(id, {
          render: res.data.description,
          type: "success",
          isLoading: false,
        });
        setTimeout(() => {
        //   toast.dismiss(id);
          window.location.reload();
        }, 2000);
      } else {
        console.log(res);
        toast.update(id, {
          render: res.data.description,
          type: "error",
          isLoading: false,
        });
      }
    })
    .catch((err) => {
      toast.update(id, {
        render: err,
        type: "error",
        isLoading: false,
      });
    });
}



  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=' rounded-lg  p-4 pt-10'> 
          
            <div className=' '>
           
                <div className=' d-flex justify-content-end'>
                   
                    <div>
                    <CancelIcon onClick={handleClose} className=' text-black cursor-pointer text-[38px]' fontSize="large"/>
                    
                    </div>
                </div>
                <h5 className=' px-4 '>Promo discount</h5>
                <form onSubmit={setThresholdValue} className="row">
       <div className="row">
       <div className="col-3"></div>
       <div className="col-12">
       
                <div className=' my-2'>
                <label className=' mb-2'>Discount Airtime :</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspAirtimee}
                    onChange={(e) => setDspAirtime(e.target.value)}
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'> Discount Cable :</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspCablee}
                    onChange={(e) => setDspCablee(e.target.value)}
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'> Discount Data:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspDataa}
                    onChange={(e) => setDspData(e.target.value)}
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'> Discount Electricity:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspElectricityy}
                    onChange={(e) => setDspElectricity(e.target.value)}
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'> Discount Internet:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspInternett}
                    onChange={(e) => setDspInternet(e.target.value)}
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'> Discount JAMB:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspJambb}
                    onChange={(e) => setDspJamb(e.target.value)}
                  />
                </div>
                <div className=' my-2'>
                <label className=' mb-2'> Discount WEAC:</label>
                <input
                    className="form-control "
                    type="text"
                    required
                    value={dspWaecc}
                    onChange={(e) => setdspWaec(e.target.value)}
                  />
                </div>
                        </div>
                        <div className="col-3"></div>
                        </div>
                        <div className=' row'>
                        <div className="col-8"></div>
                        <div className="col-3 my-3">
                        <div className="ms-auto">
                                <div className="btn-group">
                                <button type="submit" 
                                onClick={setThresholdValue}
                                className="btn btn-primary">
                                    Submit
                                </button>
                                </div>
                            </div>
                        </div>
                        </div>
                        </form>
               
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}